import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-message-popup',
    templateUrl: './message-popup.component.html',
    styleUrls: ['./message-popup.component.sass'],
    standalone: false
})

/**
 * This is how you call it 
 * popupService.openDialog(MessagePopupComponent, {
                  data : {message: "hello"}
                })
 */
export class MessagePopupComponent {

  constructor(private dialogRef: MatDialogRef<MessagePopupComponent>,
              @Inject(MAT_DIALOG_DATA) public data: { message: string }) { }

  closeDialog(): void {
    this.dialogRef.close();
  }

}